import { isCanada, isUnitedStates } from '@/lib/constants/countries';

function provinceMatchesCountry(countryCode: string, provinceCode: string): boolean {
  const country = countryCode.toUpperCase();
  const province = provinceCode.trim().toUpperCase();

  if (!province) {
    return true;
  }

  if (province.startsWith('US-')) {
    return isUnitedStates(country);
  }

  if (province.startsWith('CA-')) {
    return isCanada(country);
  }

  return true;
}

export function formatProvinceCode(countryCode: string, provinceCode: string): string {
  const country = countryCode.toUpperCase();
  const province = provinceCode.trim();

  if (!province) {
    return '';
  }

  if (isUnitedStates(country)) {
    if (province.startsWith('US-')) {
      return province.toUpperCase();
    }

    if (province.length === 2) {
      return `US-${province.toUpperCase()}`;
    }

    return province;
  }

  if (isCanada(country)) {
    if (province.startsWith('CA-')) {
      return province.toUpperCase();
    }

    if (province.length === 2) {
      return `CA-${province.toUpperCase()}`;
    }

    return province;
  }

  return province;
}

export function formatProvinceCodeForDisplay(countryCode: string | undefined, provinceCode: string | undefined): string {
  if (!provinceCode) {
    return '';
  }

  const country = (countryCode ?? 'US').toUpperCase();
  const normalized = provinceCode.trim();

  if (!provinceMatchesCountry(country, normalized)) {
    return '';
  }

  if (isUnitedStates(country) && normalized.startsWith('US-')) {
    return normalized.slice(3);
  }

  if (isCanada(country) && normalized.startsWith('CA-')) {
    return normalized.slice(3);
  }

  return normalized;
}
